import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const PendingPlanChangesDialog = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      heading={t('Pending Plan Changes')}
      buttonText={t('Close')}
      leftBtn={null}
      actionBtnColor={'blue'}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'There are currently plan changes pending. To make this change, please first cancel the pending changes.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
